<fin-editorial-page-head [title]="(activeNaviSection$ | async)?.teaserTitle" [titleAsHeading]="titleAsH1()" />

<section
  class="bluewings-main mr-medium-t grid-max-width padding-left-gutter padding-right-gutter center"
  [ngClass]="{
    'grid-col-12': removeNav(),
  }"
>
  <div
    class="grid-col-12 grid-max-width no-row-gap white-bg relative rounded-large"
    [ngClass]="{
      'col-1-12 md-col-2-11 sm-col-1-12': removeNav(),
    }"
  >
    <!-- Section navigation -->
    @if (!removeNav()) {
      <fin-light-section-navi class="col-1-12 md-col-1-3 sm-col-2-11" />
    }

    <!-- Bluewings content -->
    <section
      class="col-1-12 mr-medium-t"
      [ngClass]="{
        'md-col-4-12 sm-col-2-11': !removeNav(),
        'sm-col-1-12': removeNav(),
      }"
    >
      @if (hasContent) {
        <fin-cms-json-content @fadeIn class="grid-col-12 no-gutters no-row-gap" [template$]="template$" />
      } @else {
        <fcom-loader />
      }
    </section>
  </div>
</section>
